import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';
import { IssueSupplier, IssuesFilterSupplier, IssuesOrderSupplier, QuproList, CsiteSupplier, ProformasFilter, Proforma,
        QuproServiceError, CsitesFilterSupplier } from '@arpada/arp-lib-common-qupro';

import { PortalProveedorService, OperatorPopulateService, UiService, ConformesFilter } from '../../../services/api.services';
import { OperatorFront, ModeloError } from '../../../models/api.models';

import { ActionsSharedData } from './actions.shared.data';
import { MoreActionsIssuesComponent } from './more-actions-issues/more-actions-issues.component';
import { FilterIssuesComponent } from './filter-issues/filter-issues.component';
import { FilterProformaComponent } from './filter-proforma/filter-proforma.component';
import { OrderIssuesComponent } from './order-issues/order-issues.component';
import { FilterIssuesProformablesComponent } from './filter-issues-proformables/filter-issues-proformables.component';
import { Subscription } from 'rxjs';
import { FilterConformeComponent } from './filter-conforme/filter-conforme.component';

@Component({
  selector: 'app-actions-header',
  templateUrl: './actions-header.component.html',
  styleUrls: ['./actions-header.component.scss'],
})
export class ActionsHeaderComponent implements OnInit, OnDestroy {

  @Input() sharedData: ActionsSharedData;

  @Input() issuesFilter: IssuesFilterSupplier; // son mis filtros y order de la lib
  @Input() filtroIssue: boolean;

  @Input() postsaleFilter: boolean;
  @Input() presaleFilter: boolean;
  @Input() mantenimientoFilter: boolean;

  @Input() proformasFilter: ProformasFilter;
  @Input() filtroProforma: boolean;

  @Input() conformesFilter: ConformesFilter;
  @Input() filtroConforme: boolean;

  @Input() filtroIssueProformable: boolean;
  @Input() csite: CsiteSupplier;

  @Input() order: IssuesOrderSupplier;

  @Input() showListButton: boolean;
  @Input() showCardListButton: boolean;
  @Input() showEditOperarioButton: boolean;
  @Input() issuesToEdit: IssueSupplier[];
  @Input() comeFromIssue: boolean;
  @Input() issuesSelected: boolean;
  @Input() idsFilterIssues: number[];
  @Input() mode: string;

  @Input() showInlineEditionMenu: boolean;
  @Input() showInlineEditButton: boolean;
  @Input() showExitInlineEditButton: boolean;
  @Input() showEdMasivaButton: boolean;
  @Input() showEdMasivaErrorButton: boolean;
  @Input() edMasivaErrors: ModeloError[];

  @Input() comeFromProforma: boolean;
  @Input() showCreateProformaButton: boolean;
  @Input() proformasToExport: Proforma[];

  @Input() totalCountIssuesToSelect: number;
  @Input() showSelectAllCards: boolean;
  @Input() allCardsSelectButton: boolean;
  @Input() canFirmIssues: boolean;
  @Input() showOperatorFilter: boolean;

  @Input() comeFromConforme: boolean;

  operarios: OperatorFront[];

  @Output() public filterChange = new EventEmitter();
  @Output() public orderChange = new EventEmitter();
  @Output() public listPressed = new EventEmitter();
  @Output() public cardListPressed = new EventEmitter();
  @Output() public inlineEditPressed = new EventEmitter();
  @Output() public exitInlineEditPressed  = new EventEmitter();
  @Output() public exitEdMasivaErrorPressed  = new EventEmitter();
  @Output() public createProformaPressed  = new EventEmitter();
  @Output() public exportProformasPressed  = new EventEmitter();
  @Output() public selectAllPressed  = new EventEmitter();
  @Output() public firmIssuesEvent  = new EventEmitter();
  @Output() public uploadAgreementPressed  = new EventEmitter();


  private selectOperatorSubscription: Subscription;

  constructor(private modalController: ModalController,
              private portalProveedorService: PortalProveedorService,
              private operatorPopulateService: OperatorPopulateService,
              private uiService: UiService,
              private popoverCtrl: PopoverController) { }

  ngOnDestroy(): void {
    if (this.selectOperatorSubscription) {
      this.selectOperatorSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    const operatorSel = this.portalProveedorService.getOperatorSel();
    this.getComboCsites(this.postsaleFilter, this.presaleFilter, this.mantenimientoFilter, this.filtroProforma, operatorSel);
    this.portalProveedorService.getOperarios().subscribe(resp => {
      this.operarios = this.operatorPopulateService.convertOperatorsToOperatorsFront(resp.elements);
    });
    this.selectOperatorSubscription = this.portalProveedorService.selectOperatorEvent.subscribe(operatorId => {
      this.getComboCsites(this.postsaleFilter, this.presaleFilter, this.mantenimientoFilter, this.filtroProforma, operatorId);
    });
  }

  async getComboCsites(postsaleFilter: boolean, presaleFilter: boolean, mantenimientoFilter: boolean, filtroProforma:boolean, operator: number) {
    const filter: CsitesFilterSupplier = new CsitesFilterSupplier();
    filter.operator_num = operator;
    if (postsaleFilter) {
      this.sharedData.loadingComboCsites = true;
      return await this.portalProveedorService.getSupplierCsitesComboPostsale(filter).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        this.sharedData.csites = csitesList.elements;
        this.sharedData.loadingComboCsites = false;
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
        this.sharedData.loadingComboCsites = false;
      });
    } else if (presaleFilter) {
      this.sharedData.loadingComboCsites = true;
      return await this.portalProveedorService.getSupplierCsitesComboReviewPresale(filter)
      .subscribe((csitesList: QuproList<CsiteSupplier>) => {
        this.sharedData.csites = csitesList.elements;
        this.sharedData.loadingComboCsites = false;
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
        this.sharedData.loadingComboCsites = false;
      });
    } else if (mantenimientoFilter) {
      this.sharedData.loadingComboCsites = true;
      return await this.portalProveedorService.getSupplierCsitesComboByMode(filter, 'combo-mantenimiento').subscribe((csitesList: QuproList<CsiteSupplier>) => {
        this.sharedData.csites = csitesList.elements;
        this.sharedData.loadingComboCsites = false;
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
        this.sharedData.loadingComboCsites = false;
      });
    } else if (filtroProforma) {
      this.sharedData.loadingComboCsites = true;
      return await this.portalProveedorService.getSupplierCsitesComboByMode(filter, 'combo-proformable-proveedor').subscribe((csitesList: QuproList<CsiteSupplier>) => {
        this.sharedData.csites = csitesList.elements;
        this.sharedData.loadingComboCsites = false;
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
        this.sharedData.loadingComboCsites = false;
      });

    } else {
      this.sharedData.loadingComboCsites = true;
      return await this.portalProveedorService.getSupplierCsitesComboPostsale(filter).subscribe((csitesList: QuproList<CsiteSupplier>) => {
        this.sharedData.csites = csitesList.elements;
        this.sharedData.loadingComboCsites = false;
      }, (error: QuproServiceError) => {
        this.showErrorToast(error.message);
        this.sharedData.loadingComboCsites = false;
      });
    }
  }

  enabledMoreActions(): boolean {
    if (this.showListButton || this.showCardListButton || this.showEditOperarioButton || this.comeFromIssue || this.comeFromProforma || this.comeFromConforme) {
      return true;
    } else {
      return false;
    }
  }

  async openMoreActions(event) {
    const popover = await this.popoverCtrl.create({
      component: MoreActionsIssuesComponent,
      event,
      componentProps: {
        showCardListButton: this.showCardListButton,
        showListButton: this.showListButton,
        listPressed: this.listPressed,
        cardListPressed: this.cardListPressed,
        showEditOperarioButton: this.showEditOperarioButton,
        issuesToEdit: this.issuesToEdit,
        isPopover: true,
        comeFromIssue: this.comeFromIssue,
        sharedData: this.sharedData,
        idsFilterIssues: this.idsFilterIssues,
        issuesSelected: this.issuesSelected,
        filter: this.issuesFilter,
        mode: this.mode,
        postsaleFilter: this.postsaleFilter,
        presaleFilter: this.presaleFilter,
        showInlineEditionMenu: this.showInlineEditionMenu,
        showInlineEditButton: this.showInlineEditButton,
        inlineEditPressed: this.inlineEditPressed,
        showExitInlineEditButton: this.showExitInlineEditButton,
        exitInlineEditPressed: this.exitInlineEditPressed,
        showEdMasivaButton: this.showEdMasivaButton,
        showEdMasivaErrorButton: this.showEdMasivaErrorButton,
        exitEdMasivaErrorPressed: this.exitEdMasivaErrorPressed,
        edMasivaErrors: this.edMasivaErrors,
        showCreateProformaButton: this.showCreateProformaButton,
        createProformaPressed: this.createProformaPressed,
        comeFromProforma: this.comeFromProforma,
        proformasToExport: this.proformasToExport,
        exportProformasPressed: this.exportProformasPressed,
        totalCountIssuesToSelect: this.totalCountIssuesToSelect,
        showSelectAllCards: this.showSelectAllCards,
        selectAllPressed: this.selectAllPressed,
        firmIssuesEvent: this.firmIssuesEvent,
        allCardsSelectButton: this.allCardsSelectButton,
        canFirmIssues: this.canFirmIssues,
        comeFromConforme: this.comeFromConforme,
        uploadAgreementPressed: this.uploadAgreementPressed
      }
    });
    return await popover.present();
  }


  async openFilterIssueModal() {
    const modal = await this.modalController.create({
      component: FilterIssuesComponent,
      componentProps: {
        operarios: this.operarios,
        filter: this.issuesFilter,
        filterChange: this.filterChange,
        sharedData: this.sharedData,
        presaleFilter: this.presaleFilter,
        postsaleFilter: this.postsaleFilter,
        isModal: true,
        showOperatorFilter: this.showOperatorFilter
      }
    });
    return await modal.present();
  }

  async openFilterProformaModal() {
    const modal = await this.modalController.create({
      component: FilterProformaComponent,
      componentProps: {
        operarios: this.operarios,
        filter: this.proformasFilter,
        filterChange: this.filterChange,
        sharedData: this.sharedData,
        isModal: true
      }
    });
    return await modal.present();
  }

  async openFilterIssuesProformablesModal() {
    const modal = await this.modalController.create({
      component: FilterIssuesProformablesComponent,
      componentProps: {
        csite: this.csite,
        filter: this.issuesFilter,
        filterChange: this.filterChange,
        sharedData: this.sharedData,
        isModal: true
      }
    });
    return await modal.present();
  }

  async openFilterConformeModal() {
    const modal = await this.modalController.create({
      component: FilterConformeComponent,
      componentProps: {
        filter: this.conformesFilter,
        filterChange: this.filterChange,
        sharedData: this.sharedData,
        isModal: true
      }
    });
    return await modal.present();
  }

  async openOrderModal() {
    const modal = await this.modalController.create({
      component: OrderIssuesComponent,
      componentProps: {
        order: this.order,
        orderChange: this.orderChange,
        sharedData: this.sharedData,
        isModal: true
      }
    });
    return await modal.present();
  }

  private showErrorToast(message: string) {
    this.uiService.showMiddleToastWithButton(message, 2000000);
  }

}
